import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://thedripchexk.com";

const setTag = (selector, attr, value, create) => {
  let el = document.head.querySelector(selector);
  if (!el && create) {
    el = create();
    document.head.appendChild(el);
  }
  if (el) el.setAttribute(attr, value);
};

const SEO = ({ title, description, image, jsonLd }) => {
  const location = useLocation();
  useEffect(() => {
    const fullTitle = title ? `${title} — The Dripchexk` : "The Dripchexk — Premium Streetwear India";
    document.title = fullTitle;

    const desc = description || "Shop premium hoodies and tees from The Dripchexk. Bold designs, quality fabric, fast delivery across India. COD available. Starting ₹799.";
    const img = image || `${SITE}/og.jpg`;
    const url = `${SITE}${location.pathname}`;

    setTag('meta[name="description"]', "content", desc, () => { const m=document.createElement("meta"); m.setAttribute("name","description"); return m; });
    setTag('link[rel="canonical"]', "href", url, () => { const m=document.createElement("link"); m.setAttribute("rel","canonical"); return m; });
    setTag('meta[property="og:title"]', "content", fullTitle, () => { const m=document.createElement("meta"); m.setAttribute("property","og:title"); return m; });
    setTag('meta[property="og:description"]', "content", desc, () => { const m=document.createElement("meta"); m.setAttribute("property","og:description"); return m; });
    setTag('meta[property="og:image"]', "content", img, () => { const m=document.createElement("meta"); m.setAttribute("property","og:image"); return m; });
    setTag('meta[property="og:url"]', "content", url, () => { const m=document.createElement("meta"); m.setAttribute("property","og:url"); return m; });
    setTag('meta[name="twitter:title"]', "content", fullTitle, () => { const m=document.createElement("meta"); m.setAttribute("name","twitter:title"); return m; });
    setTag('meta[name="twitter:description"]', "content", desc, () => { const m=document.createElement("meta"); m.setAttribute("name","twitter:description"); return m; });
    setTag('meta[name="twitter:image"]', "content", img, () => { const m=document.createElement("meta"); m.setAttribute("name","twitter:image"); return m; });

    // JSON-LD
    const existing = document.head.querySelector('script[data-seo="dynamic"]');
    if (existing) existing.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo", "dynamic");
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, image, jsonLd, location.pathname]);
  return null;
};

export default SEO;
